const parseWidgetOptionsFromRegistry = (WidgetRegistry) => Object.keys(WidgetRegistry)
  .map((widgetName) => (
    {
      key: widgetName,
      text: widgetName,
      value: widgetName,
    }
  ))

export { parseWidgetOptionsFromRegistry }
